import debugLocalhost from './base/debugLocalhost'
import updateSlug from './base/updateSlug'
//import updateNavActive from './base/updateNavActive'
import scrollCtrl from './base/scrollCtrl'
import scrollReveal from './base/scrollReveal'


//import animscroll from './components/animscroll'
import ioss from './components/ioss'
//import acco from './components/acco'
//import blink from './components/blink'
//import splitter from './components/splitter'
//import paranice from './components/paranice'

// modules
//import bob from './modules/bob'
import cardpp from './modules/cardpp'
import smartvid from './modules/smartvid'
//import basicslider from './modules/basicslider'
import gridpp from './modules/gridpp'



function initPage(){

  /* Base */
  debugLocalhost()
  updateSlug()
  scrollCtrl()
  bus.emit('resizeNow')
  //updateNavActive()

  /* Components */
  ioss()
  //acco()
  //animscroll()
  //blink(document.querySelectorAll('.blink'))
  //paranice()

  /* Modules */
  //bob()
  cardpp()
  smartvid()
  gridpp()
  //basicslider()


  // split text animation
  /*document.querySelectorAll('.test-splitter').forEach($self => {
    let split = new splitter($self)
  
    const lines = $self.querySelectorAll('.splittext--line')
    lines.forEach(line => {
      line.style.overflow = 'hidden'
    })

    const tl = gsap.timeline()
    const lineIns = $self.querySelectorAll('.splittext--linein')
    lineIns.forEach((el, i) => {
      tl.fromTo(el, 
        { y: '110%', autoAlpha: 1 },
        { y: '0%', autoAlpha: 1, ease: 'power1.inOut', duration: 4 },
        0.2 * i
      )
    })
  
    tl.call(() => {
      // split.revert()
    })
  })*/

  // init contact form 7 form
  if (typeof wpcf7 !== 'undefined' && typeof wpcf7.init === 'function') {
    document.querySelectorAll('.wpcf7 form').forEach(form => {
      wpcf7.init(form)
    })
  }


  /* Base : end */
  scrollReveal()
}

export default initPage